import { resolveParamMap } from './resolveParamMap';

export interface AsyncSelectCascadingProps {
  dataSourceParams?: Record<string, string>;
  resetOnParamsChange?: boolean;
  cascadeRequiresParent?: boolean;
}

/**
 * Maps model.json `dependsOn` + `paramMap` to RhfAsyncSelect cascading props.
 *
 * - `dependsOn` → true cascade child: wait for parent params, reset value when parent changes.
 * - `paramMap` only (include-* hydration) → fetch on mount; do not reset self when include params update.
 */
export function buildAsyncSelectCascadingProps(
  paramMap: Record<string, string> | undefined,
  dependsOn: string | undefined,
  namePrefix?: string,
): AsyncSelectCascadingProps {
  if (!dependsOn && !paramMap) return {};

  const { dataSourceParams } = resolveParamMap(paramMap, namePrefix);

  if (Object.keys(dataSourceParams).length === 0 && dependsOn) {
    const depField = namePrefix ? `${namePrefix}.${dependsOn}` : dependsOn;
    dataSourceParams[dependsOn] = depField;
  }

  if (Object.keys(dataSourceParams).length === 0) return {};

  return {
    dataSourceParams,
    resetOnParamsChange: Boolean(dependsOn),
    cascadeRequiresParent: Boolean(dependsOn),
  };
}
